import { IGridServerSideDatasource, IServerSideGetRowsParams } from "@samc/centricity-core";
import { AjaxHelper } from "@samc/common";
import { ILoansSeenBefore } from "../Interfaces";
import { processAgGridRequest } from "../Functions";

export class LoansSeenBeforeSource implements IGridServerSideDatasource {
  private _helper: AjaxHelper;
  public pageSize = 50;
  public cacheSize = 10;
  public adhocFilter: string = '';

  public cachedLoans: ILoansSeenBefore[] | null = null;
  public headerLoans: ILoansSeenBefore[] | null = null;

  public constructor(packageId: string, verificationToken: string | null = null) {
    this._helper = new AjaxHelper(`/datasource/importdetails/loansseenbefore/${packageId}`, verificationToken, null, null);
  }

  public async getRows(params: IServerSideGetRowsParams) {
    try {
      if (this.cachedLoans === null) {
        this.cachedLoans = await this._helper.getData<ILoansSeenBefore[]>('');

        this.headerLoans = this.cachedLoans.filter(x => x.parentId === null);
      }

      const loans = processAgGridRequest(this.headerLoans ?? [], params.request);
      params.success({ rowData: loans, rowCount: loans.length });
    } catch {
      params.fail();
    }
  }

  public getGroupData(data: ILoansSeenBefore): ILoansSeenBefore[] {
    return this.cachedLoans?.filter(x => x.parentId === data.loanId) ?? [];
  }
}